import {
    Component,
    inject,
    OnInit,
    OnDestroy,
    HostListener,
} from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { OverviewVm } from '../../../shared/generated/Dashboard/Models/OverviewVm';
import { DispenseSettingsVm } from '../../../shared/generated/Dashboard/Models/DispenseSettingsVm';
import { LandingService } from '../../landing/landing.service';
import { SecurityService } from '../../../core/security/security.service';
import { UserJsVm } from '../../../shared/generated/Administration/Models/UserJsVm';
import { GlobalService } from '../../../shared/service/global.service';
import { CheckNetworkService } from '../../../../local-db/services/check-network.service';

@Component({
    selector: 'pcg-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false,
})
export class DashboardComponent implements OnInit, OnDestroy {
    title = inject(Title);
    private landingService = inject(LandingService);
    private securityService = inject(SecurityService);
    private router = inject(Router);
    private http = inject(HttpClient);

    overviewVm: OverviewVm;
    overviewVm$: Observable<OverviewVm>;

    user: UserJsVm;

    emergencyEvent = '';
    tankAssetNumbers: string[] = [];
    teamName = '';
    isNoTeamAssociation = false;
    isMobile: boolean;
    isOnline: boolean;

    @HostListener('window:resize') onResize() {
        this.isMobile = GlobalService.setIsMobile(window.innerWidth);
    }

    ngOnInit() {
        this.title.setTitle('Dashboard');
        this.isOnline = CheckNetworkService.checkNetworkStatus();
        this.user = this.securityService.getUser();
        this.isMobile = GlobalService.setIsMobile(window.innerWidth);
        document.body.classList.add('splash-background-color');
        document.body.classList.add('dashboard-flex');
        document.getElementById('footer')?.classList.add('nav-text-color');
        this.getMobileDashboardInfo();
        this.overviewVm$ = this.landingService.getOverviewVm().pipe(
            tap((model: OverviewVm) => {
                this.overviewVm = model;
            })
        );
    }

    getMobileDashboardInfo() {
        this.http
            .get('api/Dashboard/GetMobileDashboardInfo')
            .subscribe((mobileInfo: DispenseSettingsVm) => {
                this.emergencyEvent = mobileInfo?.emergencyEvent!;
                this.tankAssetNumbers = mobileInfo?.tankAssetNumbers!;
                this.teamName = mobileInfo?.teamName!;

                if (
                    (this.emergencyEvent == null ||
                        this.emergencyEvent == undefined) &&
                    (this.tankAssetNumbers?.length == 0 ||
                        this.tankAssetNumbers == undefined) &&
                    (this.teamName == null || this.teamName == undefined)
                ) {
                    this.isNoTeamAssociation = true;
                }
            });
    }

    ngOnDestroy() {
        document.body.classList.remove('splash-background-color');
        document.body.classList.remove('dashboard-flex');
        document.getElementById('footer')?.classList.remove('nav-text-color');
    }

    goToDispense() {
        this.router.navigate(['events/dispense-event-list'], {
            state: { fromDashboard: true },
        });
    }
}
